var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"align-center justify-center"},[_c('v-col',{staticStyle:{"overflow-x":"auto"},attrs:{"cols":"12","md":"12","align-self":"center"}},[_c('div',{staticStyle:{"min-width":"450px","min-height":"350px"},attrs:{"id":"chart-station-sensors"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }